<template>
  <transition name="fade">
    <div class="l_loading" style="z-index: 2147483647;">
      <div class="l_loading__animation">
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.l_loading {
  position: fixed;
  top: 0;
  left: 0;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.9);
}

.l_loading__animation {
  height: 40px;
  width: 40px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  border-top-color: #efb80c;
  animation: spinner 600ms linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
</style>
